<template>
  <span>
    <ViewBar :hidden="true"></ViewBar>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 class="text-center" mt-5>
          <h1 id="msg_welcome">{{ $t('landing.welcome') }}</h1>
        </v-flex>
        <v-flex
          v-if="!this.$store.getters.isAuthenticated"
          xs12
          sm6
          offset-sm3
          class="text-center"
          mt-5
        >
          <!--v-btn color="primary" to="/signup" id="btn_signup">{{ $t('landing.button.signup') }}</v-btn-->
          <v-btn
            v-if="!this.$store.getters.isAuthenticated"
            to="/signin"
            id="btn_signin"
          >{{ $t('landing.button.signin') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </span>
</template>

<script>
import ViewBar from "../components/viewbar/ViewBar";

export default {
  components: {
    ViewBar,
  },

};
</script>
